export default {
  finance: {},
  campaign: {
    list: {
      campaignName: 'Campaign Name',
      image: 'Image',
      quota: 'Quota',
      minLimit: 'Min Limit',
      maxLimit: 'Max Limit',
      workingCost: 'Working Cost',
      deliveryDate: 'Delivery Date',
      startDate: 'Start Date',
      endDate: 'End Date',
      actions: 'Actions',
      newCampaign: 'New Campaign'
    },
    usageList: {
      usageView: 'Usage View',
      campaignUsageList: 'Campaign Usage List',
      employeeAdvantageUsageList: 'Employee Advantage List',
      packageUsageList: 'Pakage Usage List',
      referenceRuleUsageList: 'Referance Usage List',
      campaignName: 'Campaign Name',
      customerName: 'Customer Name',
      userName: 'User Name',
      financeAmount: 'Finance Amount',
      financeType: 'Finance Type',
      methodType: 'Method Type',
      advantagePartyType: 'Advantage Party Type',
      advantageParty: 'Advantage Party',
      proposalDate: 'Proposal Date',
      productDate: 'Product Date',
      status: 'Status',
      partyName: 'Party Name',
      definitionName: 'Definition',
      order: 'Order',
      quotaRatio: 'Quota Ratio',
      proposalStatus: 'Proposal Status',
      productStatus: 'Product Status',
      referanceCount: 'Reference Count',
      no: 'No',
      proposalNo: 'Proposal No',
      appliedAdvantageNo: 'Applied Advantage No',
      appliedMonth: 'Applied Month',
      appliedRatio: 'Applied Ratio',
      isItProduct: 'Is It Product ?',
      product: 'Product',
      proposal: 'Proposal'
    },
    create: {
      campaignCategory: 'Category list is empty, define a category first.',
      campaignCategories: 'Campaign Categories:',
      campaignName: 'Campaign Name',
      dateRange: 'Date Range',
      minLimit: 'Min Limit',
      maxLimit: 'Max Limit',
      chooseStartDate: 'Choose Start Date',
      chooseEndDate: 'Choose End Date',
      chooseFile: 'Choose File',
      campaignQuota: 'Campaign Quota',
      workingCost: 'Working Cost',
      deliveryDate: 'Delivery Date',
      properties: 'Properties',
      canUseInitiative: 'Can Use Initiative',
      campaignNameMessage: 'Enter Campaign Name!',
      minLimitMessage: 'Enter Min Limit!',
      maxLimitMessage: 'Enter Max Limit!',
      startDateMessage: 'Enter Start Date!',
      endDateMessage: 'Enter End Date!',
      user: 'User',
      proposalNo: 'Proposal No',
      appliedMonth: 'Applied Month',
      appliedRatio: 'Applied Ratio',
      isItProduct: 'Is It Product?',
      product: 'Product',
      proposal: 'Proposal',
      campaignImageMessage: 'Choose Campaign Image!'
    },
    placeholder: {
      enterCampaignName: 'Enter Campaign Name',
      chooseCategory: 'Choose Category',
      chooseStartDate: 'Choose Start Date',
      chooseEndDate: 'Choose End Date'
    }
  },
  category: {
    list: {
      addProductCategory: 'Add Product Category',
      productCategory: 'Product Category Code',
      productMainCategory: 'Product Main Category',
      value: 'Value',
      productValue: 'Product Value',
      productsMainCategory: 'Products Main Category',
      code: 'Category Code',
      parentCode: 'Category Main Code',
      userCode: 'User Code',
      date: 'Date',
      actions: 'Actions'
    }
  },
  limit: {
    list: {
      addAdvantageToPersonal: 'Add Advantage To Personal',
      addingAdvantageToPersonal: 'Adding Advantage To Personal',
      limitName: 'Limit Name',
      userCode: 'User Code',
      usableRatio: 'Usable Ratio',
      ratio: 'Ratio',
      usableMonth: 'Usable Month',
      customerCount: 'Customer Count',
      no: 'No',
      staffCode: 'Staff Code',
      totalCustomer: 'Total Customer',
      remainCustomerCount: 'Remain Customer Count',
      totalMonth: 'Total Month',
      remainMonthCount: 'Remain Mounth Counts',
      startDate: 'Start Date',
      endDate: 'End Date'
    },
    usageList: {
      no: 'No',
      customerNo: 'Customer No',
      proposalNo: 'Proposal No',
      userCode: 'User Code',
      usedRatio: 'Used Ratio',
      usedMonth: 'Used Month',
      isItProduct: 'Is It Product?'
    },
    placeholder: {
      enterLimitName: 'Enter Limit Name'
    }
  },
  product: {
    list: {
      customerNo: 'Customer No',
      chooseCategory: 'Choose Category',
      month: 'Month',
      installment: 'Installment',
      payAmount: 'Pay Amount',
      remain: 'Remain',
      payScope: 'Status',
      productId: 'Product Id',
      customer: 'Customer',
      amount: 'Amount',
      bargainAmount: 'Bargain Amount',
      installmentAmount: 'Installment Amount',
      status: 'Status',
      continue: 'Continue',
      finished: 'Finished',
      id: 'Id',
      agent: 'Agent',
      purpose: 'Purpose',
      category: 'Category',
      deliveryDate: 'Delivery Date',
      workingCost: 'Working Cost',
      initial: 'Initial',
      success: 'Success',
      deleted: 'Deleted',
      identificationNumber: 'Identification Number',
      customerName: 'Customer Name',
      phoneNumber: 'Phone Number',
      financeType: 'Finance Type',
      methodType: 'Method Type',
      financeAmount: 'Finance Amount',
      proposeUser: 'Propose User',
      productUser: 'Product User'
    }
  },
  sale: {
    mainForm: {
      customer: 'Customer',
      editor: 'Editor',
      financialCalculation: 'Finance Calculation Parameters',
      financeType: 'Finance Type',
      methodType: 'Method Type',
      financeAmount: 'Finance Amount',
      bargainAmount: 'Bargain Amount',
      installmentAmount: 'Installment Amount',
      yearlyPaymentIncreaseRatio: 'Yearly Payment Increase Ratio',
      increaseAfterDelivery: 'Increase After Delivery',
      interimPayment: 'Interim Payment',
      enterDate: 'Enter Date',
      ineterimPaymentCost: 'Interim Payment Cost',
      purpose: 'Purpose',
      description: 'Description',
      clear: 'Clear',
      calculate: 'Calculate'
    },
    paymentTable: {
      fileName: 'File Name',
      cellWidth: 'Cell Width(Auto):',
      true: 'True',
      false: 'False',
      export: 'Export',
      loading: 'Loading',
      month: 'Month',
      year: 'Year',
      payAmount: 'Pay Amount',
      remainAmount: 'Remain Amount'
    }
  }
};